export type NormalizedInlineEditValue =
  | { status: 'invalid' }
  | { status: 'unchanged'; value: string }
  | { status: 'changed'; value: string };

/** Trims the draft; an empty draft is invalid and one equal to the current value is unchanged. */
export const normalizeInlineEditValue = ({
  draft,
  currentValue,
}: {
  draft: string;
  currentValue: string;
}): NormalizedInlineEditValue => {
  const value = draft.trim();
  if (!value) return { status: 'invalid' };
  if (value === currentValue) return { status: 'unchanged', value };
  return { status: 'changed', value };
};
